import styled from 'styled-components';
import { MenuLateralTemplateProps } from '.';
import { ROUTE_TO_BREAKPOINT } from '@/hooks/useBreakpoint';

export const Container = styled.div<MenuLateralTemplateProps>`
  position: fixed;
  top: ${({ $alturaToolBar }) => `${$alturaToolBar}px`};
  left: 0;
  height: calc(100vh - ${({ $alturaToolBar }) => `${$alturaToolBar}px`});
  width: 80vw;
  background-color: ${({ theme }) => theme.panel.solid};

  display: flex;
  flex-direction: column;
  z-index: 1000;

  transform: ${({ $estaAberto }) =>
    $estaAberto ? 'translateX(0)' : 'translateX(-100%)'};
  transition: transform 0.3s ease-in-out;

  gap: ${({ theme }) => theme.spacing['4']}px;

  @media (min-width: ${ROUTE_TO_BREAKPOINT['/']}px) {
    display: none;
  }
`;
